// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".listDescription[data-v-0d8239ec] {\n  margin: 10px 0 1px;\n  color: #666;\n}", ""]);
// Exports
module.exports = exports;
